import angular from 'angular';
import { DatalayerUtils } from 'src/app/shared/ib-datalayer-utils';
import { DatalayerConstantsType } from 'ib-web-commons/dist/app/core/ib-datalayer/ib-datalayer-constants';

const componentOptions = {
    bindings: {
        bundles: '='
    },
    controllerAs: 'ibBundelingCtrl',
    templateUrl: [
        '$rootScope', function ($rootScope) {
            return $rootScope.routes.templates + 'ib-bundeling-view.html';
        }]
};


const componentInfo = {
    module: 'ib-bundeling-module',
    selector: 'ibBundeling',
    inject: ['ModalServiceAncillaries', '$scope', 'localStorageService', 'AncillariesConstants', '$filter', '$rootScope', 'DatalayerUtils', 'DatalayerUtilsService', 'DatalayerConstants'],
    required: ['']
};


export class ibBundeling implements ng.IController {
    public bundles: any;
    public viewOnCardOne: boolean = true;
    public viewOnCardTwo: boolean = false;
    public viewOnCardThree: boolean = false;
    public itemsInBundle: any;
    totalPassengers: number;
    constructor (
        private ModalServiceAncillaries: any,
        private $scope: angular.IScope,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private AncillariesConstants: AncillariesConstant,
        private $filter: angular.IFilterService,
        private $rootScope: CommonsRootScope,
        private DatalayerUtils: DatalayerUtils,
        private DatalayerUtilsService: DatalayerUtilsService,
        private DatalayerConstants: DatalayerConstantsType
    ) {
        this.$rootScope.$on('changeButtonStyleBundle', this.changeButtonStyleBundle);
        this.$rootScope.$on('isTotalRefund', this.setRefundDescription);
    }

    $onInit (): void {
        const currency: CommonsCurrencyModel.CurrencyResponse = this.localStorageService.get('currency');
        const bookingInfo: any = this.localStorageService.get('bookingInfo');
        const selectedBundle: any = this.localStorageService.get('selectedBundle');
        let passAndSegments: number;
        if(bookingInfo && bookingInfo.order && bookingInfo.order.slices && bookingInfo.passengers) {
            this.totalPassengers = bookingInfo.passengers.length;
            passAndSegments = this.totalPassengers * bookingInfo.order.slices.length;
            if(passAndSegments === 0) {
                passAndSegments = 1;
            }
        }
        this.bundles.bundles.forEach(bundle => {
            bundle.selected = false;
            bundle.totalPassengers = this.totalPassengers;
            if(selectedBundle && selectedBundle.id === bundle.id) {
                bundle.selected = true;
            }
            bundle.allDiscountFormated = Math.floor(bundle.priceItemsAllDiscount / passAndSegments) + currency.currencySymbol;
            bundle.priceItemsBenefitFormatted = this.$filter('translate')('BUNDLE_SAVE').replace('#', Math.floor(bundle.priceItemsAllBenefit) + '').replace('€', currency.currencySymbol);
            bundle.items.forEach((item: any) => {
                item.quantityPassAndTrips = item.quantity / passAndSegments;
                item.text = this.getBundleItemDescription(item.type, item.subtype ? item.subtype : '');
            });
        });
        if(this.bundles.bundles.length > 1) {
            angular.element('#bundeling-carrousel').bind('scroll', this.checkFixed);
        }

        this.DatalayerUtils.getAncillariesDigitalDataEcommerce('bundle', this.DatalayerConstants.EVENTS_ECOMMERCE.VIEW_ITEM_LIST);
        this.DatalayerUtilsService.updateDatalayerViewEvent();

        if(this.localStorageService.get('bundleHaveBaggs') === undefined || this.localStorageService.get('bundleHaveSpeqs') === undefined) {
            this.localStorageService.remove('bundleHaveSpeqs');
            this.localStorageService.remove('bundleHaveBaggs');
            for(let i = 0; i < this.bundles.bundles.length; i++) {
                this.bundles.bundles[i].items.forEach(item => {
                    switch(item.type) {
                            case this.AncillariesConstants.TYPE_ANCILLARIE.BAGGAGE:
                                this.localStorageService.set('bundleHaveBaggs', false);
                                break;
                            case this.AncillariesConstants.TYPE_ANCILLARIE.SPEQS:
                                this.localStorageService.set('bundleHaveSpeqs', false);
                                break;
                        //case this.AncillariesConstants.TYPE_ANCILLARIE.FLEXIBILITY: bundle.hasFlex = true; break;
                        //case this.AncillariesConstants.TYPE_ANCILLARIE.PRIORITY_BOARDING: bundle.hasPrio = true; break;
                    }
                });
            }
        }
    }

    getBundleItemDescription = (type: string, subtype: string) => {
        let description = '';
        switch (type) {
                case this.AncillariesConstants.TYPE_ANCILLARIE.BAGGAGE:
                    switch (subtype) {
                            case this.AncillariesConstants.ANCILLARIES_SUBTYPES.BAGGAGE_15:
                                description =  this.$filter('translate')('BAGGAGE_SINGULAR_TEXT') + ' ' + this.AncillariesConstants.ANCILLARIES_BAGGAGES_SUBTYPES_DESCRIPTION.BAGGAGE_15;
                                break;
                            case this.AncillariesConstants.ANCILLARIES_SUBTYPES.BAGGAGE_23:
                                description =  this.$filter('translate')('BAGGAGE_SINGULAR_TEXT') + ' ' + this.AncillariesConstants.ANCILLARIES_BAGGAGES_SUBTYPES_DESCRIPTION.BAGGAGE_23;
                                break;
                            case this.AncillariesConstants.ANCILLARIES_SUBTYPES.BAGGAGE_32:
                                description =  this.$filter('translate')('BAGGAGE_SINGULAR_TEXT') + ' ' + this.AncillariesConstants.ANCILLARIES_BAGGAGES_SUBTYPES_DESCRIPTION.BAGGAGE_32;
                                break;
                    }
                    break;
                case this.AncillariesConstants.TYPE_ANCILLARIE.SPEQS:
                    switch (subtype) {
                            case this.AncillariesConstants.SPEQ_TYPE.SKI_SNOW:
                                description =  this.$filter('translate')('SPEQS_SKI_SNOW');
                                break;
                            case this.AncillariesConstants.SPEQ_TYPE.GOLF_EQUIPMENT: description =  this.$filter('translate')('SPEQS_GOLF_EQUIPMENT'); break;
                            case this.AncillariesConstants.SPEQ_TYPE.FISHING_EQUIPMENT: description =  'Equipamiento de pesca'; break;
                            case this.AncillariesConstants.SPEQ_TYPE.SCUBA_DIVING: description =  'Equipamiento de buceo'; break;
                            case this.AncillariesConstants.SPEQ_TYPE.SURFBOARD: description =  'Equipamiento de surf'; break;
                            case this.AncillariesConstants.SPEQ_TYPE.BICYCLE: description =  this.$filter('translate')('SPEQS_BICYCLE'); break;
                            case this.AncillariesConstants.SPEQ_TYPE.SPORTING_FIREARMS: description =  'Armas deportivas'; break;
                            default: description =  this.$filter('translate')('ANCILLARIES_SPEQS_TITLE_TEXT'); break;
                    }
                    break;
                case this.AncillariesConstants.TYPE_ANCILLARIE.FLEXIBILITY:
                    switch (subtype) {
                            case this.AncillariesConstants.FLEX_SUBTYPES.FLIGHT_CHANGE: description =  this.$filter('translate')('ANCILLARIES_FLEXIBILITY_FLIGHT_CHANGE_TITLE'); break;
                            case this.AncillariesConstants.FLEX_SUBTYPES.VOUCHER_REFUND: description =   getCapitalLetterAfterBracket(this.$filter('translate')('ANCILLARIES_FLEXIBILITY_VOUCHER_REFUND_CHANGE_TITLE')); break;
                            case this.AncillariesConstants.FLEX_SUBTYPES.FLEXIBILITY_PACK: description =  this.$filter('translate')('ANCILLARIES_FLEXIBILITY_PACK_FLEXIBILITY'); break;
                    }
                    break;
                case this.AncillariesConstants.TYPE_ANCILLARIE.PRIORITY_BOARDING: description =  this.$filter('translate')('PRIORITY_BOARDING_TITLE'); break;
        }
        description = description.substring(0, 1).toUpperCase() + description.substring(1, description.length);
        return description;

        function getCapitalLetterAfterBracket (literal: string): string {
            return literal.substring(0, literal.indexOf('(')) +
                    literal.substring(literal.indexOf('('), literal.indexOf('(') + 2).toUpperCase() +
                    literal.substring(literal.indexOf('(') + 2, literal.length);
        }

    };

    setRefundDescription = (event: any, isTotalRefund: boolean) => {

        if(isTotalRefund) {
            const voucherBundle: any = this.bundles.bundles.filter(bundle => bundle.items.some(item => item.subtype === 'VOUCHER_REFUND'))[0];

            const flexibilityBundle: any = this.bundles.bundles.filter(bundle => bundle.items.some(item => item.subtype === 'FLEXIBILITY_PACK'))[0];

            if(voucherBundle) {
                const voucherItem: any = voucherBundle.items.filter(item => item.subtype === 'VOUCHER_REFUND')[0];
                voucherItem.text = this.$filter('translate')('ANCILLARIES_VOUCHER_REFUND_MODAL_TITLE');
                voucherItem.isTotalRefund = isTotalRefund;
            }
            if(flexibilityBundle) {
                const flexibilityItem: any = flexibilityBundle.items.filter(item => item.subtype === 'FLEXIBILITY_PACK')[0];
                flexibilityItem.isTotalRefund = isTotalRefund;
            }
        }
    };

    checkFixed = () => {
        const carrousel = $('#bundeling-carrousel').innerWidth();
        const scroll = $('#bundeling-carrousel').scrollLeft();

        if(this.bundles.bundles.length === 3) {
            const bundleCard = carrousel / 4;
            if(scroll <= bundleCard) {
                this.viewOnCardOne = true;
                this.viewOnCardTwo = false;
                this.viewOnCardThree = false;
            } else if(scroll > 185 && scroll <= 380) {
                this.viewOnCardOne = false;
                this.viewOnCardTwo = true;
                this.viewOnCardThree = false;
            } else if (scroll > 380) {
                this.viewOnCardOne = false;
                this.viewOnCardTwo = false;
                this.viewOnCardThree = true;
            }
        } else {
            if(scroll <= 100) {
                this.viewOnCardOne = true;
                this.viewOnCardTwo = false;
            } else if(100 < scroll) {
                this.viewOnCardOne = false;
                this.viewOnCardTwo = true;
            }
        }
        this.$scope.$apply();
    };
    openBundelingModal = (items) => {
        this.ModalServiceAncillaries.showMoreInfoPerBundleModal({itemsInBundle: items});
    };

    selectBundle = (id: string, items: any) => {
        const passengerBaggagesTrips: any = this.localStorageService.get('passengerBaggagesTrips');
        this.bundles.bundles.forEach((bundle: any) => {
            if(bundle.id === id) {
                const previousBundleHasBaggs: boolean = this.checkPreviousBundleHasBaggs();
                bundle.selected = !bundle.selected;
                if(bundle.selected) {
                    this.localStorageService.set('selectedBundle', bundle);
                    if(this.localStorageService.get('bundleHaveSpeqs') === true) {
                        this.$rootScope.$broadcast('maxSpeqsAlert');
                    }
                    if(this.localStorageService.get('bundleHaveBaggs') === true) {
                        this.$rootScope.$broadcast('maxBaggsAlert');
                    }
                    if(this.localStorageService.get('bundleHaveSpeqs') !== true && this.localStorageService.get('bundleHaveBaggs') !== true) {
                        this.lockPrioAndFlex(bundle.items);
                        this.$rootScope.$broadcast('checkPrioAndFlex');
                        this.$rootScope.$broadcast('updateHeaderBundle', bundle);
                        this.localStorageService.set('ancillariesAction', 'addtocart');
                        this.DatalayerUtils.setSelectItemAndAddToCartBundle(bundle);
                        this.$rootScope.$broadcast('updateHeaderBaggages', passengerBaggagesTrips);

                    } else {
                        this.localStorageService.set('selectedBundle', null);
                        bundle.selected = false;
                    }
                } else {
                    this.unlockPrioAndFlex(bundle.items);
                    this.localStorageService.set('selectedBundle', null);
                    this.$rootScope.$broadcast('updateHeaderBundle', null);
                    items.forEach((item: any) => {
                        if(item.type === 'BAGGAGE') {
                            this.$rootScope.$broadcast('updateHeaderBaggages', passengerBaggagesTrips);
                            this.$rootScope.$broadcast('checkBaggages');
                        }
                    });
                    if(previousBundleHasBaggs) {
                        this.$rootScope.$broadcast('checkBaggages', true);
                    }
                    bundle.items.forEach(item => {
                        switch(item.type) {
                                case 'FLEXIBILITY_ON_DEMAND':
                                    this.$rootScope.$broadcast('cleanFlexibilization');
                                    break;
                                case 'PRIORITY_BOARDING':
                                    this.$rootScope.$broadcast('cleanPriorityBoarding');
                                    break;
                                default:
                                    break;
                        }
                    });
                }
            } else {
                bundle.selected = false;
            }
        });
    };

    checkPreviousBundleHasBaggs () : boolean {
        this.bundles.bundles.forEach(bundle => {
            if(bundle.selected) {
                bundle.items.forEach(item => {
                    if(item.type === 'BAGGAGE') {
                        return true;
                    }
                });
            }
        });
        return false;
    }

    lockPrioAndFlex = (items) => {
        for(let i = 0; i < items.length; i++) {
            if(items[i].type === 'FLEXIBILITY_ON_DEMAND' || items[i].type === 'PRIORITY_BOARDING' ) {
                this.$rootScope.$broadcast('lockItemsFromBundle');
            }
        }
    };

    unlockPrioAndFlex = (items) => {
        this.localStorageService.remove('bundleItems');
        for(let i = 0; i < items.length; i++) {
            if(items[i].type === 'FLEXIBILITY_ON_DEMAND' || items[i].type === 'PRIORITY_BOARDING' ) {
                this.$rootScope.$broadcast('unlockItemsFromBundle');
            }
        }
    };

    changeButtonStyleBundle = (evt) => {
        this.bundles.bundles.forEach(bundle => {
            if (bundle.selected) {
                bundle.selected = false;
            }
        });
    };
}

try {
    const mod = angular.module(componentInfo.module);
    ibBundeling.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibBundeling })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibBundeling.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibBundeling })
    );
}